import React, { FC } from 'react'

import { AutoStoryWrapper } from 'modules/Feed/components'

import { relativeDate, relativeDay } from 'shared/utils/formatDate'
import { getCoverImagePath } from 'shared/utils/getCoverImagePath'
import { getChartAttr } from 'shared/utils/chartConfig'

import { PeakStoryProps } from './PeakStory.props'

import './PeakStory.scss'

const PeakStory: FC<PeakStoryProps> = ({ chartData, ...props }) => {
  const distanceFromNow = relativeDate(props?.story?.facts?.position_current_at || '')
  const currentDay = relativeDay(props?.story?.facts?.position_current_at || '')
  const chartMeta = getChartAttr(props?.story?.facts?.chart || '')

  return (
    <AutoStoryWrapper {...props} type={props.story.argument_type}>
      <div className="peak-story">
        <div className="story__position peak-story__position">
          <div className="peak-story__position-count">{JSON.parse(props?.story?.properties || '')?.peak}</div>
          <div className="peak-story__position-divider" />
          <img
            className="story__avatar peak-story__avatar"
            alt={props?.story?.product_id || ''}
            src={getCoverImagePath(props.story.product_id)}
          />
        </div>
        <div className="peak-story__content">
          <div className="peak-story__content-title">
            <b>{`${props?.story?.product?.name} `}&nbsp;</b>
            {`/ ${chartMeta?.name}`} {`${chartData || ''} `}&nbsp;
            <span className={`${chartMeta?.icon || ''}`} />
          </div>
          <div className="peak-story__content-subtitle">
            With a peak of <b>{JSON.parse(props?.story?.properties || '')?.peak}</b> at {currentDay}, {props?.story?.product?.name}{' '}
            entered the charts <b>{distanceFromNow}</b> on {currentDay}.
          </div>
        </div>
      </div>
    </AutoStoryWrapper>
  )
}

export default PeakStory
